// @flow

import React, { useState, useCallback } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { createClasses } from '../utils/stylesUtils';
import filterSearchBoxStyles from './Styles/FilterSearchBox.Style';
type Props = {
  handleSetSearchInputValue: Function,
  searchInputValue: String,
  placeholderValue?: string
};

const FilterSearchBox = (props: Props) => {
  const { handleSetSearchInputValue, searchInputValue, placeholderValue } = props;
  const theme = useTheme();
  const classes = createClasses(filterSearchBoxStyles, theme);
  const [value, setValue] = useState(searchInputValue);
  
  const handleChangeValue = useCallback((e) => {
    setValue(e.target.value);
    handleSetSearchInputValue(e.target.value);
  }, [handleSetSearchInputValue]);

  return (
    <Paper
      sx={classes.root}
      elevation={1}
    >
      <InputBase
        sx={classes.input}
        onChange={handleChangeValue}
        placeholder={ placeholderValue ? placeholderValue : 'Search...'}
        value={value}
      />
      <IconButton
        aria-label='Search'
        sx={classes.iconButton}
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

export default FilterSearchBox;